<!-- Global Upload Status Indicator -->
<div *ngIf="(hasActiveUploads() || hasCompletedUploads() || hasFailedUploads()) && showNotification" 
     class="global-upload-status position-fixed" 
     [class.slide-out]="!showNotification"
     style="top: 20px; right: 20px; z-index: 1050;">
  
  <!-- Active Uploads Indicator -->
  <div *ngIf="hasActiveUploads()" 
       class="alert alert-info d-flex align-items-center mb-2 shadow-sm" 
       style="min-width: 300px;">
    <div class="spinner-border spinner-border-sm me-2" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="flex-grow-1">
      <strong>{{getActiveUploadsCount()}} upload(s) in progress</strong>
      <br>
      <small>Processing in background...</small>
    </div>
    <button class="btn btn-sm btn-outline-info ms-2" 
            (click)="showUploadStatus = true">
      <i class="fa fa-eye"></i>
    </button>
  </div>

  <!-- Completed Uploads Notification -->
  <div *ngIf="hasCompletedUploads()" 
       class="alert alert-success d-flex align-items-center mb-2 shadow-sm" 
       style="min-width: 300px;">
    <i class="fa fa-check-circle me-2"></i>
    <div class="flex-grow-1">
      <strong>{{getCompletedUploadsCount()}} upload(s) completed</strong>
      <br>
      <small>Data is now available in your system</small>
    </div>
    <button class="btn btn-sm btn-outline-success ms-2" 
            (click)="showUploadStatus = true">
      <i class="fa fa-eye"></i>
    </button>
  </div>

  <!-- Failed Uploads Notification -->
  <div *ngIf="hasFailedUploads()" 
       class="alert alert-danger d-flex align-items-center mb-2 shadow-sm" 
       style="min-width: 300px;">
    <i class="fa fa-exclamation-triangle me-2"></i>
    <div class="flex-grow-1">
      <strong>{{getFailedUploadsCount()}} upload(s) failed</strong>
      <br>
      <small>Action required</small>
    </div>
    <button class="btn btn-sm btn-outline-danger ms-2" 
            (click)="showUploadStatus = true">
      <i class="fa fa-eye"></i>
    </button>
  </div>
</div>


<!-- Global Upload Status Modal -->
<div *ngIf="showUploadStatus" class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-upload"></i> System Upload Status
        </h5>
        <button type="button" class="btn-close" (click)="showUploadStatus = false" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="uploadTasks.length === 0" class="text-center py-4">
          <i class="fa fa-inbox fa-3x text-muted mb-3"></i>
          <p class="text-muted">No uploads in progress or completed.</p>
        </div>
        
        <div *ngIf="uploadTasks.length > 0">
          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="card text-center">
                <div class="card-body">
                  <i class="fa fa-upload fa-2x text-primary mb-2"></i>
                  <h5 class="card-title">{{getActiveUploadsCount()}}</h5>
                  <p class="card-text">Active</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card text-center">
                <div class="card-body">
                  <i class="fa fa-check fa-2x text-success mb-2"></i>
                  <h5 class="card-title">{{getCompletedUploadsCount()}}</h5>
                  <p class="card-text">Completed</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card text-center">
                <div class="card-body">
                  <i class="fa fa-times fa-2x text-danger mb-2"></i>
                  <h5 class="card-title">{{getFailedUploadsCount()}}</h5>
                  <p class="card-text">Failed</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Upload Tasks List -->
          <div class="upload-tasks-list">
            <div *ngFor="let task of uploadTasks" class="upload-task-item mb-3 p-3 border rounded">
              <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center mb-2">
                    <i class="fa fa-file-excel me-2 text-success"></i>
                    <strong>{{task.fileName}}</strong>
                    <span class="badge bg-secondary ms-2">{{task.module | titlecase}}</span>
                    <span class="badge ms-2" 
                          [class]="task.status === 'pending' ? 'bg-secondary' : 
                                   task.status === 'uploading' ? 'bg-primary' :
                                   task.status === 'processing' ? 'bg-warning' :
                                   task.status === 'completed' ? 'bg-success' : 'bg-danger'">
                      {{task.status | titlecase}}
                    </span>
                  </div>
                  
                  <div class="text-muted small mb-2">
                    <i class="fa fa-file"></i> {{formatFileSize(task.fileSize)}} | 
                    <i class="fa fa-clock"></i> {{task.startTime | date:'short'}}
                    <span *ngIf="task.endTime"> | 
                      <i class="fa fa-check"></i> {{task.endTime | date:'short'}}
                    </span>
                  </div>
                  
                  <!-- Progress Bar -->
                  <div *ngIf="isTaskInProgress(task)" class="mb-2">
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar progress-bar-striped progress-bar-animated" 
                           [class]="getProgressBarClass(task)"
                           [style.width.%]="task.progress" 
                           role="progressbar">
                      </div>
                    </div>
                    <small class="text-muted">{{task.progress | number:'1.0-0'}}% complete</small>
                  </div>
                  
                  <!-- Error Message -->
                  <div *ngIf="isTaskFailed(task) && task.error" class="alert alert-danger py-2 mb-0">
                    <small><i class="fa fa-exclamation-triangle"></i> {{task.error}}</small>
                  </div>
                  
                  <!-- Success Message -->
                  <div *ngIf="isTaskCompleted(task)" class="alert alert-success py-2 mb-0">
                    <small><i class="fa fa-check-circle"></i> Upload completed successfully</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showUploadStatus = false">Close</button>
      </div>
    </div>
  </div>
</div>
